import base from './base';

const portfolioAPI = dispatch => {
    return {
        async getList() {
            return base.privateApi(dispatch, {
                path: `/v_port/list`,
                method: 'get'
            });
        },
        async getDetail(portfolioId) {
            return base.privateApi(dispatch, {
                path: `/v_port/${portfolioId}`,
                method: 'get'
            });
        },
        async rename(portfolioId, data) {
            return base.privateApi(dispatch, {
                path: `/v_port/${portfolioId}`,
                method: 'put',
                data
            });
        },
        async remove(portfolioId) {
            return base.privateApi(dispatch, {
                path: `/v_port/remove/${portfolioId}`,
                method: 'delete'
            });
        },
        async create(data) {
            return base.privateApi(dispatch, {
                path: `/v_port/add`,
                method: 'post',
                data
            });
        },
        async buyStock(portfolioId, data) {
            return base.privateApi(dispatch, {
                path: `/v_port/investment/${portfolioId}/buy`,
                method: 'post',
                data
            });
        },
        async sellStock(portfolioId, data) {
            return base.privateApi(dispatch, {
                path: `/v_port/investment/${portfolioId}/sell`,
                method: 'post',
                data
            });
        },
    };
};

export default portfolioAPI;